import { useState } from 'react';
import { Icon } from '../utils/icons';
import { useNavigate } from 'react-router-dom';
import WidgetTypeModal from './CreateWidget/WidgetTypeModal';

const CreateWidgetCard = () => {
    const navigate = useNavigate();
    const [showWidgetTypeModal, setShowWidgetTypeModal] = useState(false);

    const handleWidgetTypeSelect = (type) => {
        if (type === 'review') {
            navigate('/create-widget');
        } else if (type === 'whatsapp') {
            navigate('/create-widget?type=whatsapp');
        } else if (type === 'appointment') {
            navigate('/create-widget?type=appointment');
        }
    };

    return (
        <div className="bg-white rounded-2xl border border-gray-100 p-6 hover:shadow-lg transition-all duration-300 h-full">
            <div className="text-center h-full flex flex-col">
                {/* Preview Image - Larger Size */}
                <div className="mb-6">
                    <img
                        src="/review_widgets.gif"
                        alt="Review Widgets Preview"
                        className="w-full max-w-sm mx-auto rounded-xl shadow-sm"
                        style={{ height: '240px', objectFit: 'contain' }}
                    />
                </div>

                {/* Heading - Single Line */}
                <h3 className="text-xl font-bold text-gray-900 mb-3">
                    Transform Reviews Into <span className="text-blue-600">Customer Magnets</span>
                </h3>

                {/* Description - Two Lines */}
                <p className="text-gray-600 mb-6 text-sm leading-relaxed max-w-sm mx-auto">
                    Build trust instantly with beautiful review widgets<br />
                    that convert visitors into customers.
                </p>

                {/* CTA Button - Reduced Width & Centered */}
                <div className="mb-6">
                    <button
                        onClick={() => setShowWidgetTypeModal(true)}
                        className="bg-gradient-to-r from-blue-600 to-indigo-600 text-white px-8 py-3 rounded-xl font-semibold hover:from-blue-700 hover:to-indigo-700 transition-all duration-300 inline-flex items-center space-x-2 shadow-lg hover:shadow-xl"
                    >
                        <Icon name="add" size={18} />
                        <span>Create Widget Now</span>
                    </button>
                </div>

                {/* Features - Horizontal Small Cards */}
                <div className="mt-auto">
                    <div className="grid grid-cols-3 gap-2">
                        <div className="flex flex-col items-center p-3 bg-gray-50 rounded-lg">
                            <div className="w-6 h-6 bg-green-100 rounded-full flex items-center justify-center mb-2">
                                <Icon name="check" className="text-green-600" size={10} />
                            </div>
                            <span className="text-xs font-medium text-gray-700 text-center leading-tight">5-Minute<br />Setup</span>
                        </div>

                        <div className="flex flex-col items-center p-3 bg-gray-50 rounded-lg">
                            <div className="w-6 h-6 bg-blue-100 rounded-full flex items-center justify-center mb-2">
                                <Icon name="palette" className="text-blue-600" size={10} />
                            </div>
                            <span className="text-xs font-medium text-gray-700 text-center leading-tight">Fully<br />Customizable</span>
                        </div>

                        <div className="flex flex-col items-center p-3 bg-gray-50 rounded-lg">
                            <div className="w-6 h-6 bg-purple-100 rounded-full flex items-center justify-center mb-2">
                                <Icon name="web" className="text-purple-600" size={10} />
                            </div>
                            <span className="text-xs font-medium text-gray-700 text-center leading-tight">Mobile<br />Optimized</span>
                        </div>
                    </div>
                </div>
            </div>

            {/* Widget Type Selection Modal */}
            <WidgetTypeModal
                isOpen={showWidgetTypeModal}
                onClose={() => setShowWidgetTypeModal(false)}
                onSelectType={handleWidgetTypeSelect}
            />
        </div>
    );
};

export default CreateWidgetCard;
